<template>
    <div>
        <div v-if="!sent" class="form-lead text-left">
            <!-- h*****pot -->
            <label style="position: absolute; top: 0px; left: 0px; z-index: -1; width: 0px; height: 0px; opacity: 0;"><span>Name</span> <input v-model="honeypot" role="presentation" autocomplete="off" tabindex="-1" type="text"></label>

            <h5 class="text-custom m-b-15"><i class="far fa-envelope m-r-10"></i> Tem interesse? Envie uma mensagem para {{ user.full_name }}.</h5>
            <div class="form-group" v-bind:class="{'has-error': errors.has('full_name')}">
                <label for="full_name" class="control-label">Nome</label>
                <input type="text" v-validate="'required|max:90'" v-model="form.full_name" maxlength="90" class="form-control" name="full_name" />
                <span class="help-block text-left" v-show="errors.has('full_name')">
                    <strong>{{ errors.first('full_name') }}</strong>
                </span>
            </div>
            <div class="form-group" v-bind:class="{'has-error': errors.has('email')}">
                <label for="email" class="control-label">Email</label>
                <input type="email" v-validate="'required|email'" v-model="form.email" class="form-control" name="email" />
                <span class="help-block text-left" v-show="errors.has('email')">
                    <strong>{{ errors.first('email') }}</strong>
                </span>
            </div>
            <div class="form-group" v-bind:class="{'has-error': errors.has('phone')}">
                <label for="phone" class="control-label">Telefone de Contato</label>
                <input id="phone" v-validate="'required'" class="form-control" v-mask="['(##) ####-####', '(##) #####-####']" name="phone" v-model="form.phone" type="tel">
                <span class="help-block text-left" v-show="errors.has('phone')">
                    <strong>{{ errors.first('phone') }}</strong>
                </span>
            </div>
            <div class="form-group" v-bind:class="{'has-error': errors.has('message')}">
                <label for="message" class="control-label">Mensagem</label>
                <textarea name="message" v-validate="'required'" class="form-control" v-model="form.message" :placeholder="'Digite aqui sua mensagem para ' + user.first_name + '.'" rows="4"></textarea>
                <span class="help-block text-left" v-show="errors.has('message')">
                    <strong>{{ errors.first('message') }}</strong>
                </span>
                <div class="scroll-wrap" data-simplebar>
                    <div class="text-helpers">
                        <p v-for="(text, index) in text_suggestions" :key="index" @click="copyText(index)">{{ text }}</p>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <span>Ao preencher este formulário, seus dados são compartilhados com a {{ user.full_name }}, para que possam entrar
                    em contato contigo diretamente.</span>
            </div>

            <button @click="submitMessage($event)" type="submit" class="btn btn-success btn-invitation btn-lg btn-block waves-effect waves-light ladda-button">
                <span class="ladda-label">Enviar Mensagem</span>
            </button>
        </div>

        <div v-if="sent" class="dv_msg msg_success">
            <img class="icon" src="/images/sent.svg" alt="">
            <h4 class="text-custom">Mensagem enviada com sucesso. E agora?</h4>
            <p>Enviamos sua mensagem para {{ user.first_name }}. Aguarde um retorno para continuar o contato, ou clique no botão abaixo e envie uma mensagem pelo Whatsapp</p>
            <div>
                <phone-whatsapp-block
                    :fk_user="user.id"
                    :name="user.full_name"
                    :cta_url="cta_url"
                    :fk_property_ad="fk_property_ad"
                ></phone-whatsapp-block>
                <hr>
                <p>Aproveite e baixe nosso app, para encontrar mais oportunidades de quartos e locais para alugar.</p>
                <div class="row link_app m-b-15">
                    <a class="m-r-10" href="https://play.google.com/store/apps/details?id=com.webquarto.b2c.app&referrer=utm_source%3Dwebquarto_website%26utm_medium%3Dwebsite_footer" target="_blank">
                        <img src="https://play.google.com/intl/en_us/badges/static/images/badges/pt-br_badge_web_generic.png" alt="" width="130" srcset="">
                    </a>
                    <a href="https://apps.apple.com/br/app/webquarto/id1490298196" target="_blank">
                        <img src="https://www.webquarto.com.br/images/appstore.png" alt="" width="120">
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PhoneWhatsappBlock from '../invitation-form/phone-whatsapp-block.vue';

export default {
    components: {PhoneWhatsappBlock},
    props: [
        'user',
        'message_sent',
        'fk_property_ad',
        'authenticated',
        'location_object',
        'proommate',
        'pinvitation',
        'rent_price',
        'active_premium',
        'view_phone_amount',
        'cta_url',
        'chat_visible',
    ],
    data: function () {
        return {
            honeypot: '',
            sent: false,
            form: {
                full_name: '',
                email: '',
                phone: '',
                message: '',
                fk_user_host: this.user.id,
                fk_property_ad: this.fk_property_ad
            },
            text_suggestions: [
                'Tenho interesse neste anúncio.',
                'Este quarto ainda está disponível?',
                'Gostaria de mais informações sobre o quarto.',
            ]
        }
    },
    methods: {
        copyText(index) {
            this.form.message = this.text_suggestions[index];
        },
        submitMessage($e) {
            if (this.honeypot != '')
                return;

            this.$validator.validateAll().then(res => {
                if (!res)
                    return;

                axios.post('/guestlead/create', this.form).then(res => {
                    window.App.success('Sua mensagem foi enviada com sucesso!');
                    this.sent = true;

                    window.dataLayer.push({
                        'event': 'send-guest-lead',
                        'event_category': 'property_ad_page',
                        'event_label': 'host-' + this.user.id,
                    });
                });
            });
        }
    },
    created() {
        this.$validator.localize('pt_BR', {
            messages: {
                required: 'Este campo é obrigatório.',
                email: 'Preencha um endereço de email válido no campo acima.'
            },
        });
    }
}
</script>
